const subscriptionPlanTypes = {
  FREE: 'FREE',
  PAY_AS_YOU_GO: 'PAY_AS_YOU_GO',
  ANNUAL_COMMITMENT: 'ANNUAL_COMMITMENT',
  ENTERPRISE: 'ENTERPRISE',
};

export default subscriptionPlanTypes;
